import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToPricelist: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <a
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      href={intl.formatMessage(
        {
          id: "pricelistUrl",
          defaultMessage: "{vgUrl}/fi-fi/hinnasto#luotettava-kumppani",
        },
        {
          vgUrl: config?.vgUrl,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToPricelist;
